const MOBILE_WIDTH_BREAKPOINT = '767px'
const TABLET_WIDTH_BREAKPOINT = '991px'
const SMALL_MONITOR_WIDTH_BREAKPOINT = '1200px'

const MOBILE_VIEW_OVERRIDE = `@media screen and (max-width: ${MOBILE_WIDTH_BREAKPOINT})`
const TABLET_VIEW_OVERRIDE = `@media screen and (max-width: ${TABLET_WIDTH_BREAKPOINT})`
const SMALL_MONITOR_VIEW_OVERRIDE = `@media screen and (max-width: ${SMALL_MONITOR_WIDTH_BREAKPOINT})`

export {
  MOBILE_WIDTH_BREAKPOINT,
  TABLET_WIDTH_BREAKPOINT,
  SMALL_MONITOR_WIDTH_BREAKPOINT,
  MOBILE_VIEW_OVERRIDE,
  TABLET_VIEW_OVERRIDE,
  SMALL_MONITOR_VIEW_OVERRIDE,
}
